import React from "react";
import { II } from "../../components/common/Icons";
import { AvatarDisplay } from "../../components/common/AvatarUpload";
import { usePermissions } from "../../hooks/usePermissions";import "../../assets/styles/HR/HrSidebar.css";

const NAV = [
{ k: "dashboard", l: "Dashboard", i: "dashboard" },
{ k: "interns", l: "Interns", i: "users" },
{ k: "employees", l: "Employees", i: "users" },
{ k: "people", l: "People", i: "users" },
{ k: "attendance", l: "Attendance", i: "clock" },
{ k: "payroll", l: "Payroll", i: "rupee" },
{ k: "advances", l: "Advances", i: "rupee" },
{ k: "reports", l: "Reports", i: "file" },
{ k: "bulk", l: "Uploads", i: "upload" },
// { k: "performance", l: "Performance", i: "chart" },
{ k: "tickets", l: "Help Desk", i: "shield" },
{ k: "policies", l: "Policies", i: "file" },
{ k: "announcements", l: "Announcements", i: "bell" },
{ k: "notifications", l: "Notifications", i: "bell" },
{ k: "calendar", l: "Calendar", i: "calendar" },
{ k: "chat", l: "Chat", i: "chat" },
{ k: "notes", l: "Notes", i: "file" },
{ k: "audit", l: "Audit Log", i: "shield" },
{ k: "analytics", l: "Analytics", i: "chart" },
{ k: "offboarding", l: "Offboarding", i: "logout" },
{ k: "settings", l: "Settings", i: "settings" }];


const ic = {
  dashboard: 'dash', users: 'users', clock: 'clock', calendar: 'cal', dollar: 'dollar', rupee: 'rupee',
  chart: 'chart', bell: 'bell', chat: 'send', file: 'note', shield: 'shield',
  upload: 'bulk', logout: 'door', settings: 'gear'
};

function HrSidebar({ a, set, onLogout, user, sidebarOpen, setSidebarOpen }) {
  const { canShowNav } = usePermissions();
  const visibleNAV = NAV.filter((n) => canShowNav(n.k));
  return (
    <div
      className={`SB ${sidebarOpen ? "SB-open" : "SB-closed"}`}
      onMouseEnter={() => setSidebarOpen?.(true)}
      onMouseLeave={() => setSidebarOpen?.(false)}
    >
      <div className="SB-hd">
        <img src="/logo.png" alt="AMS" className="SB-logo hrsidebar-inline-1" />
        <div>
          <div className="hrsidebar-inline-2">AMSHRMS</div>
          <div className="hrsidebar-inline-3">HR Admin</div>
        </div>
      </div>
      <nav className="SB-nav">
        <div className="SB-sec">Overview</div>
        {visibleNAV.filter((n) => ['dashboard'].includes(n.k)).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(ic[n.i] || n.i)}<span>{n.l}</span></div>)}
        <div className="SB-sec">People</div>
        {visibleNAV.filter((n) => ['interns', 'employees', 'people'].includes(n.k)).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(ic[n.i] || n.i)}<span>{n.l}</span></div>)}
        <div className="SB-sec">Operations</div>
        {visibleNAV.filter((n) => ['attendance', 'payroll', 'advances', 'reports', 'bulk', 'tickets'].includes(n.k)).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(ic[n.i] || n.i)}<span>{n.l}</span></div>)}
        <div className="SB-sec">Communication</div>
        {visibleNAV.filter((n) => ['policies', 'announcements', 'notifications', 'calendar', 'chat'].includes(n.k)).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(ic[n.i] || n.i)}<span>{n.l}</span></div>)}
        <div className="SB-sec">Admin</div>
        {visibleNAV.filter((n) => ['notes', 'audit', 'analytics', 'offboarding', 'settings'].includes(n.k)).map((n) => <div key={n.k} className={"NI" + (a === n.k ? " on" : "")} onClick={() => set(n.k)}>{II(ic[n.i] || n.i)}<span>{n.l}</span></div>)}
      </nav>
      <div className="SB-ft">
        <div className="hrsidebar-inline-4">
          <AvatarDisplay src={user?.avatar} name={user?.name} size={34} />
          <div>
            <div className="hrsidebar-inline-5">{user?.name || 'HR Admin'}</div>
            <div className="hrsidebar-inline-6">HR Admin</div>
          </div>
        </div>
        <button onClick={onLogout} className="hrsidebar-inline-7">
          {II("logout")} Sign Out
        </button>
      </div>
    </div>);

}

export default HrSidebar;
